<template>
  <div class="form-date-input form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="disabled"
        @click.native="showDateTimePicker"
      >
        <cube-input
          v-if="renderSence === 'edit'"
          class="form-input"
          v-model="dateValue"
          :readonly="true"
          :disabled="disabled"
          :placeholder="placeholder"
          :tabindex="tabindex"
        ></cube-input>
        <span v-if="renderSence === 'read'">{{ dateValue || '-' }}</span>
      </x-proxy-form-item>
      <div v-if="!disabled && dateValue" class="form-date-select-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }" @click="clear">
        <x-svg-icon class="arrow-right" name="clear"></x-svg-icon>
      </div>
      <div v-else-if="!disabled" class="form-date-select-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }" @click="showDateTimePicker">
        <x-svg-icon  class="arrow-right" name="arrow-right-icon"></x-svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'

export default {
  name: 'FormDateSelect',
  mixins: [FormWidgetConfigMixin],
  computed: {
    columnCount() {
      const DATE_DISPLAY_MAP = {
        DATE_TIME: 6,
        YEAR_MONTH: 2,
        ONLY_YEAR: 1
      }
      return DATE_DISPLAY_MAP[this.widget.dateDisplayStyle] || 3
    },
    placeholder() {
      return this.widget.enableRule
        ? '自动生成'
        : this.widget.readOnly
          ? ''
          : this.widget.placeholder
    },
    disabled() {
      return this.widget.enableRule || this.widget.readOnly
    },
    dateValue: {
      get() {
        return this.formValue ? this.format(this.formValue) : ''
      },
      set(value) {
        this.formValue = value
      }
    }
  },
  methods: {
    format(value) {
      const FORMAT_MAP = {
        1: 'YYYY',
        2: 'YYYY-MM',
        3: 'YYYY-MM-DD',
        6: 'YYYY-MM-DD HH:mm:ss'
      }
      return this.$dayjs(value).format(FORMAT_MAP[this.columnCount])
    },
    showDateTimePicker() {
      if (this.renderSence === 'edit' && !this.widget.readOnly && !this.widget.enableRule) {
        this.$createDatePicker({
          title: this.widget.label,
          min: new Date(1170, 0, 1, 0, 0, 0),
          max: new Date(new Date().getFullYear() + 100, 11, 31, 23, 59, 59),
          value: this.formValue ? this.$dayjs(this.formValue).toDate() : new Date(),
          format: {
            year: 'YYYY',
            month: 'MM',
            date: 'DD',
            hour: 'HH',
            minute: 'mm',
            second: 'ss'
          },
          columnCount: this.columnCount,
          onSelect: (date, selectedVal, selectedText) => {
            if (selectedText && selectedText.length > 3) {
              console.log(selectedText)
              this.dateValue = selectedText.slice(0, 3).join('-') + ' ' + selectedText.slice(3).join(':')
            } else {
              this.dateValue = selectedText.join('-')
            }
          },
          onCancel: () => {}
        }).show()
      }
    },
    clear() {
      this.dateValue = ''
    }
  }
}
</script>

<style lang="scss">
.form-date-input {
  background-color: $--app-light-color;

  .form-item-label {
    font-size: $--app-title-font-size;
    line-height: 1;
    display: flex;
    font-weight: $--app-base-font-weight;
  }
  .form-item-content {
    z-index: 1;
    position: relative;
    .form-input {
      .cube-input {
        .cube-input-field {
          color: $--app-base-font-color;
          font-size: $--app-title-font-size;
        }
      }
      .cube-input::after {
        border: 0;
      }
      .cube-input_active::after {
        border: 0;
      }
    }
    .form-date-select-suffix {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.43rem;
      height: calc(100% - 1.71rem);
      &.full-height {
        height: 100%;
      }

      .arrow-right {
        display: flex;
        align-items: center;
        color: $--app-notice-color;
      }
    }
  }
  .readonly-background {
    background-color: $--app-form-readonly-bgColor !important;

    .cube-input-field {
      background-color: $--app-form-readonly-bgColor !important;
      color: $--app-base-font-color !important;
    }
    .x-proxy-form-item-content {
      .cube-input {
        background-color: $--app-form-readonly-bgColor !important;
        color: $--app-base-font-color !important;
      }
      input:disabled {
        opacity: 1 !important;
      }
    }
  }
}
.cube-picker-choose {
  height: 3.571429rem;
  .cube-picker-cancel {
    font-size: $--app-title-font-size;
    color: $--app-primary-color;
    height: 3.571429rem;
    line-height: 3.571429rem;
  }
  .cube-picker-confirm {
    font-size: $--app-title-font-size;
    color: $--app-primary-color;
    height: 3.571429rem;
    line-height: 3.571429rem;
  }
  .cube-picker-title-group {
    .cube-picker-title {
      font-size: $--app-title-font-size;
      font-weight: normal;
    }
  }
}
</style>